/**
 * /internet — migrated from public/js/internet.js.
 *
 * 1. MiniPopup pe header.internet a.point — afiseaza tooltip cu locatie + buton.
 * 2. .more-info Tooltip
 * 3. Inputs focus/blur .lb-focused
 * 4. Radio label .checked propagation
 * 5. navMenu pe header.internet nav.disk + .layer-2 .row.locations
 * 6. .btn-more reveal .more-details
 * 7. #test Form (speed-test) + #request-form Form (internet request)
 */
import { Resort } from '../core/resort.js';

new Resort((rt) => {
    function initMiniPopup(): void {
        const form = $('#request-form') as HTMLFormElement | null;
        let ui: HTMLElement | null = null;

        ($('header.internet a.point', true) as NodeListOf<Element>).Tooltip();

        ($('header.internet', true) as NodeListOf<Element>).on('click', 'a.point', function (this: Element, e: Event) {
            e.stopPropagation();
            ui?.remove();

            const target = this as HTMLElement;
            const location = target.dataset['title']  ?? '';
            const text     = target.dataset['text']   ?? '';
            const button   = target.dataset['button'] ?? '';

            ui = $(`<div class="mini-popup"><h3>${location}</h3><p>${text}</p><button><span>${button}</span></button></div>`) as HTMLElement | null;
            if (!ui) return;
            document.body.append(ui);

            const offset = target.offset();
            ui.css({
                top:  `${Math.round(offset.top - ui.clientHeight + 2)}px`,
                left: `${Math.round(offset.left - ui.clientWidth / 2 + target.clientWidth / 2)}px`,
            });
            ui.classList.add('popup-grow-show');
            ui.addEventListener('animationend', function (this: HTMLElement) {
                this.classList.remove('popup-grow-show');
            }, { once: true });

            ui.on('click', 'button', function (this: Element, ev: Event) {
                ev.stopPropagation();
                if (ui) {
                    ui.classList.add('popup-grow-hide');
                    ui.addEventListener('animationend', function (this: HTMLElement) { this.remove(); }, { once: true });
                }
                if (!form) return;
                form.style.display = 'block';
                const h = Math.round(form.clientHeight);
                form.style.height = `${h}px`;
                form.classList.add('popup-fixed', 'fade-in');
                form.addEventListener('animationend', function (this: HTMLElement) {
                    this.classList.remove('fade-in');
                    const backdrop = $('<div class="popup-modal fade-in" />') as Element | null;
                    if (backdrop) this.before(backdrop);
                });
            });

            form?.on('click', 'a.close', function () {
                ($('.popup-modal') as Element | null)?.remove();
                form.classList.add('fade-out');
                form.addEventListener('animationend', function (this: HTMLElement, ev: Event) {
                    ev.stopPropagation();
                    this.style.display = 'none';
                    this.classList.remove('popup-fixed', 'fade-out');
                    this.style.height = '';
                }, { once: true });
            });
        });
    }

    ($('.layer-1 .col a.more-info', true) as NodeListOf<Element>).Tooltip();

    $('input[type="text"], textarea', true).on('focus', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p && !p.classList.contains('lb-focused')) p.classList.add('lb-focused');
    });
    $('input[type="text"], textarea', true).on('blur', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p?.classList.contains('lb-focused')) p.classList.remove('lb-focused');
    });

    /* Radio label .checked */
    $('input[type="radio"]', true).on('change', function (this: Element) {
        const label = this.parents('label') as Element | null;
        label?.siblings('.checked')[0]?.classList.remove('checked');
        if ((this as HTMLInputElement).checked) label?.classList.add('checked');
    });

    ($('header.internet nav.disk') as Element | null)?.navMenu('a', '.map');

    ($('.layer-2') as Element | null)?.on('click', 'a.btn-more', function (this: Element) {
        ((this.find('.more-details')) as HTMLElement | null)?.slideDown();
        (this as HTMLElement).style.display = 'none';
    });

    ($('.layer-2 .row.locations') as Element | null)?.navMenu('a', '.layer-2 .net-info');

    const is_en = /\/en\//.test(window.location.href);
    initMiniPopup();

    const result = $('.layer-2 .result') as HTMLElement | null;
    ($('#test') as HTMLFormElement | null)?.Form('form', 'net_test', {}, {
        valid: () => ({ host: 'nn()' }),
        return_true: (f: Record<string, unknown>) => {
            const loc = $('.layer-2 .row.locations a.active') as HTMLElement | null;
            f['location'] = loc?.dataset['loc'] ?? '';
            return true;
        },
        done: (r: unknown, data: unknown) => {
            if (r === 'Done' && result) result.html(String(data));
        },
    }, { loader: true });

    const rForm = $('#request-form') as HTMLFormElement | null;
    rForm?.Form('form', 'internet_send_request', {}, {
        valid: () => ({
            company:  'min(5)max(40)',
            name:     'min(5)max(40)',
            email:    'mail(40)',
            phone:    'min(10)max(30)',
            location: 'min(3)max(40)',
            subject:  'nn()max(100)',
            message:  'nn()max(10000)',
        }),
        done: (r: unknown) => {
            if (r === 'Done') {
                rt.notify(is_en ? 'Your request was sent successfully.' : 'Cererea ta a fost expediată cu succes.');
                rForm.reset();
            }
        },
    });
});
